import React, { useEffect, useState } from 'react';
import * as api from '../../billMemory/api';
import { memoryScoreText } from '../../billMemory/client';

const CLUE_WORDS = { phone: 'Phone', gstin: 'GSTIN' };

/**
 * Vendors: for each vendor, the lessons its bills taught, its memory score (Fix 12), the GSTINs and phones
 * learned for it, each with Forget (Fix 13), and the items it supplies (on how many bills).
 */
export default function VendorsTab() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.getVendors().then((r) => setRows(r.rows || [])).catch(() => setRows([])); }, []);
  const forgetClue = (vendorId, clueId) => api.forgetClue(clueId).then(() => setRows((list) => list.map((v) => (
    v.vendor.id === vendorId ? { ...v, clues: (v.clues || []).filter((k) => k.id !== clueId) } : v)))).catch(() => {});
  if (!rows) return <div className="bm-note">Loading…</div>;
  if (!rows.length) return <div className="bm-note">No vendor has taught anything yet.</div>;
  return (
    <table className="irr-qty-table bm-table">
      <thead><tr><th>Vendor</th><th>Learned names</th><th>Memory score (last 5 bills)</th><th>Known by</th><th>Supplies</th></tr></thead>
      <tbody>
        {rows.map((v) => (
          <tr key={v.vendor.id}>
            <td>{v.vendor.name}</td>
            <td>{v.lessons}</td>
            <td>{memoryScoreText(v.memory_score)}</td>
            <td>
              {(v.clues || []).map((k) => (
                <div key={k.id}>
                  <span>{`${CLUE_WORDS[k.kind] || k.kind} ${k.value}`}</span>{' '}
                  <button type="button" className="bm-link" onClick={() => forgetClue(v.vendor.id, k.id)}
                    style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', textDecoration: 'underline', cursor: 'pointer', font: 'inherit' }}>
                    Forget
                  </button>
                </div>
              ))}
            </td>
            <td>{v.supplies.slice(0, 12).map((s) => `${s.name} (${s.bills} ${s.bills === 1 ? 'bill' : 'bills'})`).join(', ')}{v.supplies.length > 12 ? ` and ${v.supplies.length - 12} more` : ''}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
